export default __webpack_public_path__ + "static/media/qr-onboarding.31cb28fc.png";